var $ = require('jquery');
require('jquery-match-height');


$(function() {
	$('.c-split-sections__title').matchHeight();
	$('.c-split-sections__top').matchHeight();
	$('.c-split-sections__list').matchHeight();

	
	$('.c-split-sections__click').on('click', function() {
		if ($(window).width() < 900) {
			$(this).toggleClass('isActive');
			$(this).next('.c-split-sections__wrapper').slideToggle();
		}
	});


	Object.defineProperty(Date.prototype, 'YYYYMMDDHHMMSS', {
		value: function() {
			function pad2(n) {  // always returns a string
				return (n < 10 ? '0' : '') + n;
			}

			return this.getFullYear() +
					pad2(this.getMonth() + 1) + 
					pad2(this.getDate()) +
					pad2(this.getHours()) +
					pad2(this.getMinutes()) +
					pad2(this.getSeconds());
		}
	});

	if($('.c-header__date').length){
		var startTime = new Date().YYYYMMDDHHMMSS();
		startTime = parseInt(startTime) - (parseInt($('.js-mins').text()) + parseInt($('.js-hours').text())); // - this stuff to prevent it from going into minus time, as it appeared to go to - X number of minutes, added the hour too just to be safe in case someone is one 1 page for over an hour
		var endTime = parseInt($('.c-header__date').attr('data-time'));

		var countdownTimer = setInterval(function(){
			if(endTime > startTime){
				var second = parseInt($('.c-header__date  .js-secs').text());
				var minute = parseInt($('.c-header__date .js-mins').text());
				var hour = parseInt($('.c-header__date .js-hours').text());
				var day = parseInt($('.c-header__date .js-days').text());
				if(second !== 0){
					$('.js-secs').text((second - 1));
				}else{
					$('.js-secs').text('59');
					if(minute !== 0){
						$('.js-mins').text((minute - 1));
					}else{
						$('.js-mins').text('59');
						if(hour !== 0){
							$('.js-hours').text((hour - 1));
						}else{
							$('.js-hours').text('23'); 
							$('.js-days').text((day - 1));
						}
					}
				}
				startTime++;
			}else{
				clearInterval(countdownTimer);
			}
		},1000);
	}

	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event) {
			// On-page links
			if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
			&& 
			location.hostname == this.hostname
			) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
				scrollTop: target.offset().top
				}, 1000, function() {
				// Callback after animation
				// Must change focus!
				var $target = $(target);
				$target.focus();
				if ($target.is(":focus")) { // Checking if the target was focused
					return false;
				} else {
					$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
					$target.focus(); // Set focus again
				};
				});
			}
		}

		if ($(this).attr('data-type').length) {
			jQuery("#nf-field-517").val($(this).attr('data-type')).trigger( 'change' );
		}
	});
});